// Mirrors the rule the backend validates on save: a destination that starts with a template is
// only knowable at run time, so it is trusted here, and anything else must be an absolute http(s)
// URL. Keeping the two in step is what stops the preview promising a button that save rejects.
export const willRenderCta = (label: string, url: string) => {
  const raw = url.trim();
  if (!label || !raw) {
    return false;
  }
  return raw.startsWith('{{') || /^https?:\/\//.test(raw);
};
